import { MAINTENANCE_STRATEGY_NO_SCHEDULE_INTERVAL } from "@waku-care/types/contracts/internal";

import {
  type PaginatedMaintenanceStrategy,
  type PaginatedTransformedMaintenanceStrategy,
} from "@/api/resources/maintenanceStrategies/types";
import { filterNotEmpty } from "@/utils/format";
import { nextRRuleOccasion, readableRRule } from "@/utils/rrule";

export const transformPaginatedMaintenanceStrategies = (
  _maintenanceStrategies: PaginatedMaintenanceStrategy[],
): PaginatedTransformedMaintenanceStrategy[] => {
  return _maintenanceStrategies.filter(filterNotEmpty).map((strategy) => {
    const planned_devices_count = strategy.maintenance_strategies_to_devices.length || 0;

    // schedule_interval can be empty (no recurrence)
    const interval_human =
      strategy?.schedule_interval && strategy.schedule_interval !== MAINTENANCE_STRATEGY_NO_SCHEDULE_INTERVAL
        ? readableRRule(strategy.schedule_interval)
        : null;
    // excluded_dates must be passed, otherwise the next date can point at an occurrence
    // that was already materialized or cancelled (nextRRuleOccasion aligns them to DTSTART)
    const next_date =
      strategy?.schedule_interval && strategy.schedule_interval !== MAINTENANCE_STRATEGY_NO_SCHEDULE_INTERVAL
        ? nextRRuleOccasion(strategy.schedule_interval, undefined, strategy.excluded_dates)
        : null;

    return {
      ...strategy,
      interval_human,
      next_date,
      planned_devices_count,
    };
  });
};
